import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import includes from 'lodash/includes';
import classNames from 'classnames';
import { Container } from 'reactstrap';

import env from 'Env';
import FluidImg from 'Components/Utility/FluidImg';
import imgixConfig from 'Config/imgix';
import useViewport from 'Hooks/useViewport';
import CountdownTimer from 'Components/Utility/CountdownTimer';


const renderBackground = (bgImgSrc, footerBannerName, url) => {
  const internalLink = includes(url, 'www.fanatical.com');
  const srcSet = `
            ${bgImgSrc}?${imgixConfig}&w=5000&h=400&fit=crop 5000w,
            ${bgImgSrc}?${imgixConfig}&w=4250&h=340&fit=crop 4250w,
            ${bgImgSrc}?${imgixConfig}&w=3600&h=285&fit=crop 3600w,
            ${bgImgSrc}?${imgixConfig}&w=2500&h=200&fit=crop 2500w,
            ${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop 1800w,
            ${bgImgSrc}?${imgixConfig}&w=1520&h=179&fit=crop 1520w,
            ${bgImgSrc}?${imgixConfig}&w=1200&h=143&fit=crop 1200w,
            ${bgImgSrc}?${imgixConfig}&w=992&h=107&fit=crop 992w,
            ${bgImgSrc}?${imgixConfig}&w=768&h=79&fit=crop 768w
                `;

  if (!url) {
    return (
      <div className="hero-background-container">
        <img
          srcSet={srcSet}
          sizes="100vw"
          src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
          alt={footerBannerName}
          className="hero-background"
        />
      </div>
    );
  }

  if (!internalLink) {
    return (
      <a className="hero-background-container" href={url} target="_blank" rel="noopener noreferrer">
        <img
          srcSet={srcSet}
          sizes="100vw"
          src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
          alt={footerBannerName}
          className="hero-background"
        />
      </a>
    );
  }

  return (
    <Link to={`/${url.split('/en/')[1]}`} className="hero-background-container">
      <img
        srcSet={srcSet}
        sizes="100vw"
        src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
        alt={footerBannerName}
        className="hero-background"
      />
    </Link>
  );
};

const renderBanner = (
  imgSrc,
  url,
  name,
  dealsLive,
  showDealsButton,
  countdownHasStarted,
  countdownEnd,
) => {
  let internalLink = false;
  if (includes(url, 'www.fanatical.com')) internalLink = true;

  const image = (
    <FluidImg
      src={imgSrc}
      alt={name}
      className="center-img hero-front"
      overrideWidth="100"
      subfolder="original"
      lazy={false}
    />
  );

  if (!url) {
    return <React.Fragment>
      {showDealsButton &&
        <div className={classNames('takeover-deals-container', { 'takeover-deals-container--footer': showDealsButton === 'footer' })}>
          {!countdownHasStarted &&
            <div className="takeover-deals-button">
              <FormattedMessage
                id="footerbanner.button.deals-live"
                defaultMessage="Deals Live Now: {deals}"
                values={{
                  deals: <span>{dealsLive}</span>,
                }}
              />
            </div>
          }
          {countdownHasStarted &&
            <div className="takeover-deals-button">
              <FormattedMessage
                id="footerbanner.button.ends-in"
                defaultMessage="Sale Ends In: {timer}"
                values={{
                  timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
                }}
              />
            </div>
          }
        </div>
      }
      {image}
    </React.Fragment>;
  }
  if (!internalLink) {
    return <a href={url} target="_blank" rel="noopener noreferrer">
      {showDealsButton &&
        <div className={classNames('takeover-deals-container', { 'takeover-deals-container--footer': showDealsButton === 'footer' })}>
          {!countdownHasStarted &&
            <div className="takeover-deals-button">
              <FormattedMessage
                id="footerbanner.button.deals-live"
                defaultMessage="Deals Live Now: {deals}"
                values={{
                  deals: <span>{dealsLive}</span>,
                }}
              />
            </div>
          }
          {countdownHasStarted &&
            <div className="takeover-deals-button">
              <FormattedMessage
                id="footerbanner.button.ends-in"
                defaultMessage="Sale Ends In: {timer}"
                values={{
                  timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
                }}
              />
            </div>
          }
        </div>
      }
      {image}
    </a>;
  }

  return <Link to={`/${url.split('/en/')[1]}`}>
    {showDealsButton &&
      <div className={classNames('takeover-deals-container', { 'takeover-deals-container--footer': showDealsButton === 'footer' })}>
        {!countdownHasStarted &&
          <div className="takeover-deals-button">
            <FormattedMessage
              id="footerbanner.button.deals-live"
              defaultMessage="Deals Live Now: {deals}"
              values={{
                deals: <span>{dealsLive}</span>,
              }}
            />
          </div>
        }
        {countdownHasStarted &&
          <div className="takeover-deals-button">
            <FormattedMessage
              id="footerbanner.button.ends-in"
              defaultMessage="Sale Ends In: {timer}"
              values={{
                timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
              }}
            />
          </div>
        }
      </div>
    }
    {image}
  </Link>;
};

const FooterBanner = ({
  footerBannerName,
  foreground,
  background,
  mobileBackground,
  url,
  mobileOverride,
  dealsLive,
}) => {
  let { isBelowMd, isAboveSm } = useViewport();

  if (mobileOverride) {
    isBelowMd = true;
    isAboveSm = false;
  }

  let showDealsButton = null;
  if (dealsLive && footerBannerName.toLowerCase().includes('red hot')) showDealsButton = 'footer';

  const countdownStart = '2024-07-10T15:00:00.000Z';
  const countdownEnd = '2024-07-11T15:00:00.000Z';
  let countdownHasStarted = false;
  if (Date.now() > Date.parse(countdownStart) && Date.now() < Date.parse(countdownEnd)) {
    countdownHasStarted = true;
  }

  if (isAboveSm) {
    if (background) {
      let bgImgSrc = `${env.cdnUrl}/product/original/${background}`;

      const splitSrc = background.split('.');
      if (splitSrc && splitSrc.length && splitSrc[splitSrc.length - 1] === 'gif') {
        bgImgSrc = `${env.srcCdnUrl}/product/original/${background}`;
      }

      return (
        <React.Fragment>
          <header className="solid-hero-container">
            {foreground &&
              <Container className="solid-center-img-container">
                {renderBanner(
                  foreground,
                  url,
                  footerBannerName,
                  dealsLive,
                  showDealsButton,
                  countdownHasStarted,
                  countdownEnd,
                )}
              </Container>
            }

            {renderBackground(bgImgSrc, footerBannerName, url)}
          </header>
        </React.Fragment>
      );
    }

    if (foreground) {
      return (
        <Container>
          <div className="center-img-container">
            {renderBanner(
              foreground,
              url,
              footerBannerName,
              dealsLive,
              showDealsButton,
              countdownHasStarted,
              countdownEnd,
            )}
          </div>
        </Container>
      );
    }
  }

  if (isBelowMd && mobileBackground) {
    return (
      <React.Fragment>
        <div className="mobile-takeover center-img-container">
          {renderBanner(
            mobileBackground,
            url,
            footerBannerName,
            dealsLive,
            showDealsButton,
            countdownHasStarted,
            countdownEnd,
          )}
        </div>
      </React.Fragment>
    );
  }

  return false;
};

FooterBanner.propTypes = {
  mobileOverride: PropTypes.bool,
  url: PropTypes.string,
  background: PropTypes.string,
  mobileBackground: PropTypes.string,
  foreground: PropTypes.string,
  footerBannerName: PropTypes.string,
  dealsLive: PropTypes.number,
};

FooterBanner.defaultProps = {
  mobileOverride: false,
  url: '',
  background: '',
  mobileBackground: '',
  foreground: '',
  footerBannerName: '',
  dealsLive: 0,
};

export default FooterBanner;
